import { Component } from '@angular/core';

import { SocialLink } from './social-link.model';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
    socialLinks: SocialLink[] = [
        {
            href: 'https://www.facebook.com/skodapolska/?fref=ts',
            title: 'ŠKODA Polska na facebooku',
            icon: './assets/images/FB.svg'
        },
        {
            href: 'https://www.instagram.com/skodapolska',
            title: 'ŠKODA Polska na instagramie',
            icon: './assets/images/IG.svg'
        },
        {
            href: 'https://www.youtube.com/user/SkodaAutoPolska',
            title: 'ŠKODA Polska na youtubie',
            icon: './assets/images/YT.svg'
        },
        {
            href: 'https://www.tiktok.com/@skodapl',
            title: 'ŠKODA Polska na tiktoku',
            icon: './assets/images/tiktok.svg'
        },
    ];
}
